var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 239,
    viewBox: "0 0 568 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.9 238.9C259.076 238.9 333.8 235.587 333.8 231.5C333.8 227.413 259.076 224.1 166.9 224.1C74.7237 224.1 0 227.413 0 231.5C0 235.587 74.7237 238.9 166.9 238.9Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2 230.3C363.2 233.3 393.9 235.7 431.9 235.7C469.8 235.7 500.6 233.3 500.6 230.3C500.6 227.3 469.9 224.9 431.9 224.9C393.9 224.9 363.2 227.3 363.2 230.3Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9 196.1L40.3001 176.3L70.7001 201L43.5001 202L60.6001 210.7L21.1001 228.1L60.7001 234L285.5 233.4L245 216.5L277.9 197.6L230.6 193L238.6 177.6L213.5 185.8L227.5 124.8L184.9 180L181.5 136.7L157.9 181.6L143.2 170.1L141.7 202.3L118.1 175.9L119.2 199L106.5 187.9L101.9 196.1Z",
    fill: "#EE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5 221.6L133.9 221.8L137.6 234.3L169.6 234.2L179.5 221.6Z",
    fill: "#66D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 153.3L115.8 145.4C115.8 145.4 100.1 145.6 88.6001 160.7C77.2001 175.8 79.4001 187.3 79.4001 187.3L90.3001 195.8L124.7 153.3Z",
    fill: "#007083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 150.2C129 150.2 107 147.7 91.9002 169C76.8002 190.3 87.7002 209 87.7002 209L124.1 234.3L137.6 234.2L146.6 222.9L155 234L160.8 228.1L169.6 234.1L259.1 233.7C259.1 233.7 270.9 212.6 263.8 189.8C263.8 189.8 223.9 188.3 201.2 212.1L196.7 226.4L187.1 204.9L129 150.2Z",
    fill: "#66D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 113.9L148.1 113.8C148.1 113.8 174.4 129 166.5 188.7L161.7 190.8L142.8 113.9Z",
    fill: "#007083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 113.9C142.8 113.9 170.3 133.9 161.8 190.8L130.9 161.9C130.8 161.9 140.7 136.3 142.8 113.9Z",
    fill: "#00BBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 199.2L46 206.4C46 206.4 66.7 231.1 117.4 226.6L117.6 221.2L46.2 199.2Z",
    fill: "#007083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3002 196.6L46.2002 199.1C46.2002 199.1 68.8002 226.3 117.5 221.1L85.3002 196.6Z",
    fill: "#00BBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 177C128.2 180.7 125.3 183.6 121.6 183.7C117.9 183.7 115 180.8 114.9 177.1C114.9 173.4 117.8 170.5 121.5 170.4C125.2 170.4 128.2 173.3 128.2 177Z",
    fill: "#007083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.3 206.2C162.3 209.1 160 211.4 157.1 211.5C154.2 211.5 151.9 209.2 151.8 206.3C151.8 203.4 154.1 201.1 157 201C159.9 201 162.3 203.3 162.3 206.2Z",
    fill: "#007083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 131.4L372.8 136.8C372.8 136.8 394.5 150.7 415.4 131.6L409.2 121.5C409.2 121.6 394.1 143.1 374 131.4Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 133.6C375.5 133.6 379.7 122.9 374.8 122.2C370.7 121.6 372.8 129.6 366.2 128.7C359.6 127.8 363.3 120.9 360.9 118.1C358.5 115.3 355.5 119.4 356.3 124.4C356.3 124.4 354.2 127.4 356.3 132.6C356.3 132.6 356.9 139.8 364.7 140.9C372.6 142 375.5 133.6 375.5 133.6Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 68.8C461.4 68.8 483.6 109.8 487.8 119.4C492 129 487.9 134.2 476.9 139C465.9 143.8 451.6 150.1 443.7 153.8C435.8 157.5 428.9 157.3 422.1 145.9C415.3 134.6 408.6 124 404.8 115.4C400.9 106.9 398.6 102.5 409.5 96C420.4 89.5 461.4 68.8 461.4 68.8Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2 69.3C437 74.1 410.7 88.6 406 91.6C401.3 94.6 394.3 95.4 387.9 85.2C381.5 75 367.6 50.5 391.8 34C420 14.8 447.8 43.8 452.6 50.8C457.5 57.8 458.1 63.1 446.2 69.3Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6 52.1C387.1 47 396.4 39.4 405.4 37.2C419.2 33.7 430 45.9 434.5 54.2C439 62.5 438.4 66.2 426.7 72.7C417.1 78 401.7 90.2 392.5 86.9C391.8 86.1 391.1 85.1 390.5 84.1C386.3 77.5 378.9 64.6 381.6 52.1Z",
    fill: "#DFD3EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6 52.1C382.2 51.5 382.9 50.9 383.6 50.3C381 62.8 388.4 75.5 392.5 82.1C393.2 83.2 393.8 84.1 394.5 84.9C403.7 88.2 419.1 76 428.7 70.7C431.6 69.1 433.8 67.7 435.4 66.3C433.8 68.3 431 70.3 426.7 72.7C417.1 78 401.7 90.2 392.5 86.9C391.8 86.1 391.1 85.1 390.5 84.1C386.3 77.5 378.9 64.6 381.6 52.1Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8 58.3C404.8 60.1 406.2 61.5 408 61.5C409.8 61.5 411.2 60.1 411.2 58.3C411.2 56.5 409.8 55.1 408 55.1C406.2 55.1 404.8 56.5 404.8 58.3Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4 69.7C392.891 69.7 394.1 68.4912 394.1 67C394.1 65.5088 392.891 64.3 391.4 64.3C389.909 64.3 388.7 65.5088 388.7 67C388.7 68.4912 389.909 69.7 391.4 69.7Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.5 98.2C495.2 101.6 494.5 105.6 495.3 109.4L497.7 111L503.3 102.8L511.5 103.1L515 110.7L509.4 118.9L511.8 120.5C515.6 119.9 519.1 117.8 521.4 114.4C525 109 524.6 102.1 520.7 97.2L544 65.2C545.9 62.7 545.2 59.1 542.6 57.3C540 55.5 536.4 56.3 534.8 59L513.7 92.5C507.8 90.6 501.2 92.8 497.5 98.2ZM540.8 63C540.2 63.8 539.1 64.1 538.3 63.5C537.5 62.9 537.2 61.8 537.8 61C538.4 60.2 539.5 59.9 540.3 60.5C541.2 61 541.4 62.2 540.8 63Z",
    fill: "#EE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.7 70.4H528L524.1 76.7L532 81.9L534.1 79.4C534.1 79.4 536.4 82.9 535.2 85.8C534 88.7 530.3 89 530.3 89C530.3 89 532.2 91.4 529.9 93.8C527.6 96.2 518.5 93.3 514.6 87.4C510.8 81.4 514.1 73.6 519.7 70.4Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5 213.1L404.8 222.6L396.4 223.5C393.8 223.8 391.8 225.8 391.5 228.4L391.3 230.2H408L420.1 220.6C421.2 219.7 421.5 218.1 420.7 216.9L418.5 213.1Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5 213.1C418.5 213.1 394.6 174.3 441.1 154.9L436.4 147.8C436.4 147.8 385.9 164.5 414.3 216L418.5 213.1Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 136.6C481 136.6 509.5 191 553.9 153.2L549.5 148C549.5 148 517.7 183.5 487.8 129.1L481 136.6Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.2 148.2L554.4 154.6C557.9 158.9 560.2 164 561.1 169.4C561.5 171.9 563.7 173.8 566.3 173.9L568.1 174L567.7 168.8C567.2 161.4 564.1 154.4 559.1 149L556.4 146C555.4 144.9 553.8 144.8 552.7 145.6L549.2 148.2Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5 123.7C475.8 115.1 458.5 83.1 453.1 73C458 70.5 461.3 68.8 461.3 68.8C461.3 68.8 483.5 109.8 487.7 119.4C491.8 128.7 488 133.9 477.7 138.6C481.6 134.8 482.4 130.2 479.5 123.7Z",
    fill: "#9F7CC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.3 27.5C431.3 26.5 449 45.3 452.7 50.8C457 57 457.9 61.9 450 67.2C447 60.3 435.5 37.4 410.3 27.5Z",
    fill: "#9F7CC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.8 10.7C425.3 7.99999 427.1 5.89999 428.4 4.59999C427.7 3.09999 428.3 1.29999 429.7 0.499986C431.2 -0.400014 433.2 0.0999864 434.1 1.69999C435 3.19999 434.5 5.19999 432.9 6.09999C431.8 6.69999 430.6 6.59999 429.6 5.99999C428.4 7.29999 426.8 9.19999 425.4 11.7C421.9 17.9 421.3 24.6 423.5 31.4L421.7 32C418.7 22.7 421.1 15.3 423.8 10.7Z",
    fill: "#39165F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6 72.1C520.6 72.1 498.8 51.1 461 69C459.3 69.8 458.2 71.6 458.2 73.5V73.7C458.2 75.8 459.6 77.7 461.6 78.4C462.8 78.8 464.2 78.7 465.4 78.2C472.2 74.9 496.9 64.2 514.2 75.3C516.1 76.5 518.6 75.8 519.7 73.8L520.6 72.1Z",
    fill: "#39165F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 568,
    height: 238.9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.876f4089.svg";
export { ForwardRef as ReactComponent };